import { isOpenDialogPayload } from '../../../../../pimster-dialog/pimster-dialog.types';
import { InternalEvent } from '../../../enums';
import {
  InternalDialogOpenPayload,
  InternalEventPayloadValidator,
} from '../../../types';

export const internalDialogOpenPayloadValidator: InternalEventPayloadValidator<
  InternalEvent.DIALOG_OPEN
> = (payload: unknown): payload is InternalDialogOpenPayload =>
  isOpenDialogPayload(payload);
